import React from 'react';
import { Link } from "react-router-dom";
import paths from '../../routes/paths';

export default function ContactPage() {
    return (
        <div className="text-center text-lg text-primary">
            Contact Page <br />
            <Link to={paths.home} className='underline text-secondary'>Go To HomePage</Link>
        </div>
    )
}
